import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const filters = {
  state: {},

  mutations: {
    updateFilters(state, data) {
      Object.keys(data).forEach(key => {
        state[key] = data[key];
      });
    },
  },

  actions: {},
};
